module.exports = __webpack_public_path__ + "static/scale-model-of-lincoln-children's-zoo-in-lincoln-nebraska-b3af8cbcf5526b2675d8553317b4207d.png";